import React from "react";
import { Modal } from "../Modal";
import { DeploymentDiffBody, useDeploymentDiff } from "./deploymentDiff";

/**
 * « Voir les changements » d'un contenu, en MODALE : enveloppe du socle partagé deploymentDiff
 * (hook + corps) pour les écrans qui n'ont pas de panneau de détail (outillage AdvancedPanel).
 * La page Publication rend le même corps inline dans sa vue maître-détail.
 */

export interface DeploymentChangesModalProps {
	show: boolean;
	onClose: () => void;
	contentId: string;
	target: "preview" | "production";
	/** Titre humain du contenu, pour l'en-tête. */
	title?: string | null;
}

export const DeploymentChangesModal: React.FC<DeploymentChangesModalProps> = ({ show, onClose, contentId, target, title }) => {
	const state = useDeploymentDiff(contentId, target, show);

	return (
		<Modal show={show} onHide={onClose} size="xl" centered>
			<Modal.Header closeButton>
				<Modal.Title>{title ? `Changements : ${title}` : "Changements en attente"}</Modal.Title>
			</Modal.Header>
			<Modal.Body scrollable>
				<DeploymentDiffBody state={state} target={target} />
			</Modal.Body>
			<Modal.Footer className="justify-between">
				<span className="text-[11px] text-slate-400">
					{state.diff?.deployedAt ? `Dernier déploiement : ${new Date(state.diff.deployedAt).toLocaleString("fr-FR")}` : ""}
				</span>
				<button
					type="button"
					onClick={onClose}
					className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-semibold text-slate-600 transition hover:bg-slate-50"
				>
					Fermer
				</button>
			</Modal.Footer>
		</Modal>
	);
};

export default DeploymentChangesModal;
